module.exports = {"login":"登录","account":"账号","pwd":"密码","accountRequiredMsg":"请输入您的账号","pwdRequiredMsg":"请输入您的密码","errorMsg1012":"您输入的账号不存在","errorMsg9000":"您输入的密码有误","errorMsg9001":"您的登陆方式错误，请切换域登陆或用户名密码方式","reset_password":"您需要修改密码","sso_login":"切换单点登录"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN-login.json
// module id = 601
// module chunks = 21